import i18nMain from './vi/i18nMain';
// import i18nValidate from './vi/i18nValidate';
import i18nCommon from './vi/i18nCommon';
import i18nEnum from './vi/i18nEnum';
import i18nComponent from './vi/i18nComponent';
import i18nColumn from './vi/i18nColumn';
import i18nPages from './vi/i18nPages';
import i18nColumnTemplate from './vi/i18nColumnTemplate';
import i18nBaseForm from './vi/i18nBaseForm';
import i18nEmployee from './vi/i18nEmployee';
import i18nDevice from './vi/i18nDevice';
import i18nWebsite from './vi/i18nWebsite';
import i18nPage from './vi/i18nPage';
import i18nAnonymous from './vi/i18nAnonymous';
import i18nUser from './vi/i18nUser';
import i18nAi from './vi/i18nAi';
import i18nDashBoard from './vi/i18nDashBoard';
import i18nExploit from './vi/i18nExploit';
import i18nAttack from './vi/i18nAttack';
import i18nCve from './vi/i18nCve';
import i18nPermission from './vi/i18nPermission';

export default {
    vi: {
        i18nMain,
        // i18nValidate,
        i18nCommon,
        i18nComponent,
        i18nEnum,
        i18nColumn,
        i18nPages,
        i18nBaseForm,
        i18nColumnTemplate,
        i18nEmployee,
        i18nDevice,
        i18nWebsite,
        i18nPage,
        i18nAnonymous,
        i18nUser,
        i18nAi,
        i18nDashBoard,
        i18nExploit,
        i18nAttack,
        i18nCve,
        i18nPermission,
    },
};